import {makeAuthRequest} from '../makeApiRequest'

const apiRequest = makeAuthRequest(true)
const prefix = process.env.REACT_APP_MERGER_SERVICE_API || 'api/merger'

export const getBasketInformation = (basketId) => {
    return apiRequest({
        url: `${prefix}/baskets/${basketId}`,
        method: 'GET'
    })
}

export const getListBaskets = (payload) => {
    return apiRequest({
        url: `${prefix}/baskets/search`,
        method: 'POST',
        data: payload
    })
}

export const addOrderToBasket = (barcode, fac = 'MCVN') => {
    return apiRequest({
        url: `${prefix}/items/${barcode}/${fac}`,
        method: 'POST'
    })
}

export const releaseBasketV2 = (basketId) => {
    return apiRequest({
        url: `${prefix}/v2/baskets/${basketId}/release`,
        method: 'POST'
    })
}

export const releaseBasket = (basketId) => {
    return apiRequest({
        url: `${prefix}/baskets/${basketId}/release`,
        method: 'POST'
    })
}

export const exportListBaskets = (payload) => {
    return apiRequest({
        url: `${prefix}/baskets/search/csv`,
        method: 'POST',
        data: payload
    })
}

export const releaseBasketByOrders = (args) => {
    return apiRequest({
        url: `${prefix}/baskets/release-by-orders`,
        method: 'POST',
        data: args
    })
}

export const getBasketUncomplete = (params, cancelToken) => {
    return apiRequest({
        url: `${prefix}/data-exports/uncompleted-items`,
        method: 'GET',
        params,
        cancelToken
    })
}

export const updateBasketPosition = (basketId, payload) => {
    return apiRequest({
        url: `${prefix}/baskets/${basketId}/position`,
        method: 'POST',
        data: payload
    })
}

export const deleteBasketPosition = (basketId) => {
    return apiRequest({
        url: `${prefix}/baskets/${basketId}/position`,
        method: 'DELETE'
    })
}

export const exportListBasketsUncompleted = (payload) => {
    return apiRequest({
        url: `${prefix}/baskets/export/item-uncompleted`,
        method: 'POST',
        data: payload
    })
}